import type { FunctionComponent } from "react";
import { useCallback, useRef, useState } from "react";

import { StyledButton } from "./styles";
import { ActionMenu } from "../ActionMenu";
import { t } from "i18next";
import { Icon, Text } from "@smartsuite/react-ui/lib";
import { useFlowCanvasMenuDismiss } from "../FlowCanvas/hooks/use-flow-canvas-menu-dismiss";

interface SmallAddActionButtonProps {
  onClick: (integrationId: string, actionId: string) => void;
  disabled: boolean;
  fullWidth?: boolean;
  /** Nested Advanced Logic (Етап 7): which advanced items the parent
   * container allows. Omitted = none (historic behavior). */
  advancedLogic?: { looping: boolean; branches: boolean };
}

export const SmallAddActionButton: FunctionComponent<
  SmallAddActionButtonProps
> = ({ onClick, disabled, fullWidth, advancedLogic }) => {
  const btnRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  useFlowCanvasMenuDismiss(useCallback(() => setIsMenuOpen(false), []));
  return (
    <>
      <StyledButton
        disabled={disabled}
        ref={btnRef}
        isActive={isMenuOpen}
        fullWidth={fullWidth}
        onClick={() => setIsMenuOpen((isOpen) => !isOpen)}
      >
        <Icon
          className="small-add-action-button-icon"
          name="plus"
          size="S"
          color="currentColor"
        />
        <Text weight="medium" className="small-add-action-button">
          {t("general.add-action")}
        </Text>
      </StyledButton>
      <ActionMenu
        filterActions={["merge-records"]}
        showAdvancedLogic={
          advancedLogic !== undefined &&
          (advancedLogic.looping || advancedLogic.branches)
        }
        advancedLogicItems={advancedLogic}
        isEnabledWidthCalculation={false}
        menuButtonRef={btnRef}
        isMenuOpen={isMenuOpen}
        setMenuOpen={setIsMenuOpen}
        onActionChange={(integrationId, actionId) =>
          // TODO find another solution for it
          setTimeout(() => onClick(integrationId, actionId), 250)
        }
        showOnboarding
      />
    </>
  );
};
